module.exports = __webpack_public_path__ + "static/media/daily_check_background_bottom_right.780ed9ff.svg";